import React, { useCallback, useContext, useEffect, useState } from 'react'
import { keyBy } from 'lodash'
import { AutoComplete, Chip } from 'components/Form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { userStatusOptions } from 'keys/userStatuses'
import { updateUserStatusFetch } from 'store/middlewares/user.crud'
import { UsersContext } from './UsersContext'
import { StatusCellStyles } from './Style'

const StatusCell = (props) => {
    const { cell, row } = props
    const { queryKey } = useContext(UsersContext)
    let value = cell.getValue()
    const queryClient = useQueryClient()

    const [status, setStatus] = useState()

    const statusKeys = keyBy(userStatusOptions, "id")
    const statusItem = statusKeys[value]

    const { mutateAsync: updateUserStatus } = useMutation({
        mutationFn: updateUserStatusFetch,
        onSuccess: () => {
            queryClient.invalidateQueries([queryKey])
        }
    })

    const onChange = useCallback((value) => {
        setStatus(value)
        updateUserStatus({ id: row.original.id, status: value.id })
    }, [row])

    useEffect(() => {
        setStatus(statusItem)
    }, [statusItem])

    return (
        <StatusCellStyles>
            <AutoComplete
                minWidth={status?.width}
                badge={status}
                options={userStatusOptions}
                placeholder={""}
                input={{
                    onChange: onChange,
                    value: status
                }}
            />
        </StatusCellStyles>
    )
}

export default StatusCell